(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      var h = this.header.offsetHeight;
      var total = 10 + h;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
      document.documentElement.style.setProperty('--psw-header-total', `${total}px`);
      document.body.style.setProperty('padding-top', `${total}px`, 'important');
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {
    var carritoMovil = document.querySelector('.psw-movil-carrito');
    if (carritoMovil) {
      carritoMovil.addEventListener('click', function(e) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          e.preventDefault();
          drawer.open(carritoMovil);
        }
      });
    }

    function abrirBusqueda() {
      var overlay = document.getElementById('psw-buscar-overlay');
      if (!overlay) return;
      overlay.classList.add('activo');
      overlay.setAttribute('aria-hidden', 'false');
      var input = document.getElementById('psw-buscar-input');
      if (input) {
        input.value = '';
        pswMostrarColecciones();
        setTimeout(function() { input.focus(); }, 60);
      }
    }

    function cerrarBusqueda() {
      var overlay = document.getElementById('psw-buscar-overlay');
      if (!overlay) return;
      overlay.classList.remove('activo');
      overlay.setAttribute('aria-hidden', 'true');
    }

    function pswMostrarColecciones() {
      var cols = document.getElementById('psw-buscar-colecciones');
      var res = document.getElementById('psw-buscar-resultados');
      if (cols) cols.style.display = '';
      if (res) { res.style.display = 'none'; res.innerHTML = ''; }
    }

    var pswSearchTimer;
    var pswSearchInput = document.getElementById('psw-buscar-input');
    if (pswSearchInput) {
      pswSearchInput.addEventListener('input', function() {
        clearTimeout(pswSearchTimer);
        var q = this.value.trim();
        if (q.length < 2) { pswMostrarColecciones(); return; }
        pswSearchTimer = setTimeout(function() { pswBuscarProductos(q); }, 280);
      });
    }

    function pswBuscarProductos(q) {
      var cols = document.getElementById('psw-buscar-colecciones');
      var res = document.getElementById('psw-buscar-resultados');
      if (!res) return;
      if (cols) cols.style.display = 'none';
      res.style.display = '';
      res.innerHTML = '<div class="psw-buscar-cargando">Buscando...</div>';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = '';
          var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
          var cols2 = (data.resources && data.resources.results && data.resources.results.collections) || [];
          var arrowSvg = '<svg class="psw-buscar-item-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>';
          if (cols2.length > 0) {
            html += '<p class="psw-buscar-titulo-seccion">COLECCIONES</p><ul class="psw-buscar-lista">';
            cols2.forEach(function(c) {
              html += '<li><a href="' + c.url + '" class="psw-buscar-coleccion-item"><div class="psw-buscar-thumb">';
              if (c.featured_image && c.featured_image.url) html += '<img src="' + c.featured_image.url + '" alt="' + c.title + '" loading="lazy">';
              html += '</div><span class="psw-buscar-item-nombre">' + c.title + '</span>' + arrowSvg + '</a></li>';
            });
            html += '</ul>';
          }
          if (prods.length > 0) {
            html += '<p class="psw-buscar-titulo-seccion">PRODUCTOS</p><ul class="psw-buscar-lista">';
            prods.forEach(function(p) {
              html += '<li><a href="' + p.url + '" class="psw-buscar-producto-item"><div class="psw-buscar-thumb">';
              if (p.featured_image && p.featured_image.url) html += '<img src="' + p.featured_image.url + '" alt="' + p.title + '" loading="lazy">';
              html += '</div><span class="psw-buscar-item-nombre">' + p.title + '</span>';
              if (p.price) html += '<span class="psw-buscar-item-precio">' + (parseInt(p.price) / 100).toFixed(2).replace('.', ',') + ' €</span>';
              html += '</a></li>';
            });
            html += '</ul>';
          }
          if (prods.length === 0 && cols2.length === 0) html = '<p class="psw-buscar-sin-resultados">Sin resultados para "' + q + '"</p>';
          res.innerHTML = html;
        })
        .catch(function() { res.innerHTML = '<p class="psw-buscar-sin-resultados">Error al buscar.</p>'; });
    }

    var buscarBtn = document.querySelector('.psw-buscar-btn');
    if (buscarBtn) buscarBtn.addEventListener('click', abrirBusqueda);

    var buscarMovilBtn = document.querySelector('.psw-buscar-movil-btn');
    if (buscarMovilBtn) buscarMovilBtn.addEventListener('click', abrirBusqueda);

    var cerrarDrawerBtn = document.getElementById('psw-drawer-cerrar-btn');
    if (cerrarDrawerBtn) {
      cerrarDrawerBtn.addEventListener('click', function() {
        var details = document.getElementById('Details-menu-drawer-container');
        if (details) details.open = false;
      });
    }

    // Ocultar flechas del hero slider cuando el menú hamburguesa está abierto
    var drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (drawerDetails) {
      function toggleSliderArrows(hide) {
        document.querySelectorAll('.psw-hs-arrow, .slider-button, .slider-buttons').forEach(function(el) {
          el.style.visibility = hide ? 'hidden' : '';
          el.style.pointerEvents = hide ? 'none' : '';
        });
      }
      new MutationObserver(function() {
        toggleSliderArrows(drawerDetails.hasAttribute('open'));
      }).observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
    }

    var cerrarBuscarBtn = document.getElementById('psw-buscar-cerrar');
    if (cerrarBuscarBtn) cerrarBuscarBtn.addEventListener('click', cerrarBusqueda);

    var fondoBuscar = document.getElementById('psw-buscar-cerrar-fondo');
    if (fondoBuscar) fondoBuscar.addEventListener('click', cerrarBusqueda);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') cerrarBusqueda();
    });
  });

  (function() {
    function actualizarOffsetHeader() {
      var wrapper = document.querySelector('.psw-header-wrapper');
      if (!wrapper) return;
      var headerTotal = 10 + wrapper.offsetHeight;
      document.documentElement.style.setProperty('--psw-header-total', headerTotal + 'px');
      document.body.style.setProperty('padding-top', headerTotal + 'px', 'important');
      // Measure where <main> actually starts after layout settles (includes announcement bar height)
      requestAnimationFrame(function() {
        var main = document.getElementById('MainContent');
        if (main) {
          var mainOffset = Math.round(main.getBoundingClientRect().top + window.scrollY);
          document.documentElement.style.setProperty('--psw-main-offset', mainOffset + 'px');
        } else {
          document.documentElement.style.setProperty('--psw-main-offset', headerTotal + 'px');
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', actualizarOffsetHeader);
    } else {
      actualizarOffsetHeader();
    }
    window.addEventListener('resize', actualizarOffsetHeader);
  })();

  } catch(e) { console.error(e); }
})();
})();
